export const SIDEBAR_COOKIE = 'floop_sidebar'
const LEGACY_SIDEBAR_KEY = 'expand-sidebar'

export function parseSidebarPreference(value: string | undefined) {
	if (value === 'expanded') return true
	if (value === 'collapsed') return false
	return null
}

let pendingSave: Promise<unknown> = Promise.resolve()

export function saveInOrder(
	url: string,
	method: 'POST' | 'PUT',
	body: FormData,
) {
	pendingSave = pendingSave.then(() =>
		fetch(url, { method, body, keepalive: true }).catch(() => {}),
	)
}

export function saveSidebarPreference(expanded: boolean) {
	const body = new FormData()
	body.set('sidebar', expanded ? 'expanded' : 'collapsed')
	saveInOrder('/resources/sidebar', 'POST', body)
}

export function takeLegacySidebarPreference() {
	try {
		const saved = localStorage.getItem(LEGACY_SIDEBAR_KEY)
		if (saved === null) return null
		localStorage.removeItem(LEGACY_SIDEBAR_KEY)
		return saved === 'true'
	} catch {
		return null
	}
}
